import { render, staticRenderFns } from "./SelectionButton2.vue?vue&type=template&id=57f35148&"
import script from "./SelectionButton2.vue?vue&type=script&lang=js&"
export * from "./SelectionButton2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports